import React, { Component } from "react";
import ReactAplayer from "react-aplayer";

import "./index.scss";

class APlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  onPlay = () => {
    console.log("on play");
  };

  onPause = () => {
    console.log("on pause");
  };

  // example of access aplayer instance
  onInit = ap => {
    this.ap = ap;
  };

  render() {
    const props = {
      mini: true,
      fixed: true,
      theme: "#F57F17",
      lrcType: 3,
      audio: [
        {
          url: "/assets/mp3/Be_Your_Everything.mp3",
          title: "Be Your Everything",
          lrc: "/assets/lyric/Be_Your_Everything",
          pic: "/assets/pic/Be_Your_Everything",
          author: "Boys Like Girls"
        }
      ]
    };
    return (
      <React.Fragment>
        <ReactAplayer
          {...props}
          onInit={this.onInit}
          onPlay={this.onPlay}
          onPause={this.onPause}
        />
      </React.Fragment>
    );
  }
}

export default APlayer;
